import React from 'react';
import About from 'views/Flux/About';

const aboutRouter = {
  path: 'about',
  element: <About />,
};

export default aboutRouter;
